import React from 'react';
import { SWISSEARCH_API_DOCUMENTATION } from 'redux/lib/constants/api-urls';
import MainComponent from './main-component';

const SwissearchApiDocumentation = (props) => {
    return (
        <MainComponent url={`${SWISSEARCH_API_DOCUMENTATION.URL}`}/>
    );
};
export default SwissearchApiDocumentation;
